module.exports = __webpack_public_path__ + "../public/img/cores-05.2a35420f.svg";